import { constants } from "../../../constants";

export default class GameResumed {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default(data) {
        this.gb.emitters.emit.web.gameResumed(data);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.EYE:
                event["uiUnBlocked"] = this._default;
                break;

            default:
                event["gameResumed"] = this._default;
        }

        return event;
    }
}
